import '../../node_modules/@fortawesome/fontawesome-free/css/all.css' // Ensure you are using css-loader
import Vue from 'vue';
import Vuetify from 'vuetify/lib';

import colors from 'vuetify/lib/util/colors'
import i18n from '../i18n';

Vue.use(Vuetify);

export default new Vuetify({
    rtl: false,
    lang: {
        t: (key, ...params) => i18n.t(key, params),
    },
    icons: {
        iconfont: 'fa', // 'mdiSvg', 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
    },
    theme: {
        themes: {
            light: {
                // topbar: colors.teal,
                topbar: colors.grey.lighten4,
                navIcon: colors.teal,
                sidebar: colors.blueGrey.darken3,
                sidebarActive: colors.white,
                bgGrey: colors.grey.lighten2,
                bgPrint: colors.grey.darken5,
                // icon: colors.shades.white,
                primary: colors.teal,
                secondary: colors.grey.darken1,
                action: colors.blue,
                actionMore: colors.blue,
                print: colors.lightBlue,
                accent: colors.deepOrange,
                danger: colors.red,
                error: colors.red,
                warning: colors.orange,
                info: colors.cyan.darken1,
                success: colors.green,
                bgGreen: colors.teal.lighten5,
                alive: colors.amber.lighten1,
                time:colors.blue.darken3
            },
            dark: {
                topbar: colors.grey.darken5,
                navIcon: colors.white,
                sidebarActive: colors.white,
                bgGrey: colors.grey.darken3,
                // icon: colors.shades.white,
                primary: colors.teal.darken2,
                secondary: colors.grey.lighten1,
                action: colors.blue.darken2,
                actionMore: colors.grey.lighten1,
                print: colors.lightBlue.darken2,
                accent: colors.deepOrange.darken2,
                danger: colors.red.darken2,
                error: colors.red.darken2,
                warning: colors.orange.darken2,
                info: colors.blueGrey.lighten1,
                success: colors.green.darken2,
                bgGreen: colors.teal.darken1,
                alive: colors.amber.darken3
            },
        },
    },
});
